module.exports = __webpack_public_path__ + "static/media/cv.19d10c49.svg";